module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('Barrier', {
    attrs: {
      "id": "edit-board-module"
    },
    on: {
      "click": _vm.cancel
    }
  }, [(_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": true
    }
  }) : _c('Container', {
    attrs: {
      "fill": true
    }
  }, [_c('EditModuleHeader', {
    attrs: {
      "module": _vm.moduleDetails
    },
    on: {
      "save": _vm.validate,
      "cancel": _vm.cancel
    }
  }), _vm._v(" "), _c('ProductsCatalog', {
    attrs: {
      "id": "products-catalog",
      "products": _vm.relatedProducts
    }
  }), _vm._v(" "), _c('section', {
    ref: "container"
  }, _vm._l((_vm.editedElements), function(element, i) {
    return _c('ModulePreview', {
      key: i,
      staticClass: "preview",
      style: (_vm.elementsPosition[i]),
      attrs: {
        "index": i,
        "element": element,
        "shadeByGroup": _vm.shadeByGroup[i],
        "highlightTester": _vm.highlightTesters[i],
        "groups": _vm.groups,
        "shadesPerProduct": _vm.shadesPerProduct,
        "size": _vm.windowResizeCount
      },
      on: {
        "mouseup": function (e) { return _vm.applyShadeTo(e, i); },
        "openMenu": _vm.openMenu,
        "closeMenu": _vm.closeMenu,
        "checkMenu": _vm.checkMenu
      }
    })
  })), _vm._v(" "), _c('ShadesCatalog', {
    attrs: {
      "id": "shades-catalog",
      "shadeSelected": _vm.shadeSelected,
      "shades": _vm.shadesPerProduct
    },
    on: {
      "selectShade": _vm.selectShade
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    ref: "menu",
    staticClass: "menu"
  }, [_c('p', [_vm._v("Higlights:")]), _vm._v(" "), _vm._l((_vm.colors), function(color, index) {
    return _c('li', {
      key: index,
      style: ({
        backgroundColor: color.code
      }),
      on: {
        "click": function($event) {
          _vm.applyHighlightTesterListener(color);
        }
      }
    })
  })], 2)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c66f87f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_module/index.vue
// module id = 3169
// module chunks = 0